<template>
  <v-card class="mx-auto" color="grey-lighten-3" max-width="448">
    <v-layout>
      <!-- Login page install webapp button -->
      <v-btn icon v-show="!$route.meta.Authorize && showWebAppButton" @click="handleInstallPWA"
        style="position: absolute;top:10px;left: 10px;cursor: pointer;z-index: 9;">
        <v-icon>mdi-open-in-app</v-icon>
      </v-btn>
      <v-navigation-drawer v-model="drawer" temporary v-if="$route.meta.Authorize">

        <v-list-item lines="two">
          <template v-slot:prepend>
            <v-avatar size="64px">
              <v-img v-if="userInfoStore.avatar" alt="Avatar"
                :src="'images/avatars/avatar-' + userInfoStore.avatar + '.png'"></v-img>
              <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
            </v-avatar>
          </template>
          <v-list-item-content>
            <v-list-item-title>{{ userInfoStore.nickname }}</v-list-item-title>
            <v-list-item-subtitle>{{ userInfoStore.username }}</v-list-item-subtitle>

            <!-- Avatar/Name & Edit Profile Modal -->
            <v-dialog max-width="500">
              <!-- Avatar/Name -->
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn v-bind="activatorProps" @click="fillProfile(); drawer = null" class="mt-1"
                  prepend-icon="mdi-account-edit" variant="tonal" size="x-small">
                  {{ $t('pages.app.myAccount') }}
                </v-btn>
              </template>
              <!-- Edit Profile Modal -->
              <template v-slot:default="{ isActive }">
                <v-card :title="$t('pages.app.editProfile')">
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <v-row>
                          <v-col cols="12">
                            <img :src="'images/avatars/avatar-' + profile.avatar + '.png'">
                          </v-col>
                          <v-col cols="6">
                            <v-icon color="primary" :disabled="profile.avatar == 1"
                              @click="profile.avatar > 1 ? profile.avatar -= 1 : 1">
                              {{ lang.prevIcon }}
                            </v-icon>
                          </v-col>

                          <v-col cols="6" :class="lang.isRtl ? 'text-left' : 'text-right'">
                            <v-icon color="primary" :disabled="profile.avatar == 26" @click="profile.avatar += 1">
                              {{ lang.nextIcon }}
                            </v-icon>
                          </v-col>


                        </v-row>


                      </v-col>
                      <v-col cols="9">

                        <v-select v-if="boxScenarios.length > 0" v-model="profile.boxscenario" :items="boxScenarios"
                          item-title="Title" item-value="Id" :label="$t('pages.app.boxScenarios')"
                          :hint="selectedScenario?.Description" persistent-hint class="mb-3">
                        </v-select>


                        <v-text-field v-model="profile.username" :label="$t('pages.app.username')"
                          :hint="$t('pages.app.usernameHint')" autocomplete="off" persistent-hint outlined class="mb-3">
                        </v-text-field>
                        <v-text-field v-model="profile.nickname" :label="$t('pages.app.name')"
                          :hint="$t('pages.app.nameHint')" autocomplete="off" persistent-hint outlined
                          class="mb-3"></v-text-field>
                        <v-text-field v-model="profile.email" :label="$t('pages.app.email')" autocomplete="off"
                          :hint="$t('pages.app.emailHint')" persistent-hint outlined type="email" class="mb-3">
                        </v-text-field>
                        <v-text-field v-model="profile.password" :label="$t('pages.app.changePassword')"
                          autocomplete="new-password" :hint="$t('pages.app.changePasswordHint')" persistent-hint
                          outlined type="password" class="mb-3">
                        </v-text-field>
                      </v-col>

                    </v-row>


                  </v-card-text>

                  <v-card-actions>
                    <!-- Logout Button -->
                    <v-dialog max-width="300">
                      <template v-slot:activator="{ props: activatorProps }">
                        <v-btn class="mr-auto" v-bind="activatorProps" color="danger">
                          {{ $t('pages.app.logout') }}
                        </v-btn> </template>

                      <template v-slot:default="{ isActive }">
                        <v-card :title="$t('pages.app.confirmLogout')">
                          <v-card-text>
                            {{ $t('pages.app.confirmLogoutText') }}
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue-grey" text @click="isActive.value = false">
                              {{ $t('pages.app.cancel') }}
                            </v-btn>

                            <v-btn color="red" text @click="logout">
                              {{ $t('pages.app.logout') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
                    <v-btn @click="isActive.value = false">
                      {{ $t('public.close') }}
                    </v-btn>

                    <v-btn color="success" @click="updateProfile">
                      {{ $t('pages.app.updateProfile') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-list-item-content>
        </v-list-item>



        <v-divider></v-divider>

        <v-list density="compact" nav>
          <router-link to="/Vocabularies" class="nav-link">
            <v-list-item prepend-icon="mdi-receipt-text"
              :title="$t('pages.app.myWords') + ' (' + userInfoStore.allVocabularyCount + ')'"></v-list-item>
          </router-link>
          <router-link to="/AddVocabulary" class="nav-link">

            <v-list-item prepend-icon="mdi-receipt-text-plus" :title="$t('pages.app.addNewWord')"></v-list-item>
          </router-link>
          <router-link to="/Boxes" class="nav-link">
            <v-list-item prepend-icon="mdi-inbox-multiple" :title="$t('pages.app.boxes')"></v-list-item>
          </router-link>
          <!-- Application Settings -->
          <v-dialog max-width="500">
            <template v-slot:activator="{ props: activatorProps }">
              <v-list-item prepend-icon="mdi-cog" :title="$t('pages.app.applicationSettings')"
                value="Application Settings" v-bind="activatorProps" @click="drawer = null"></v-list-item>
            </template>
            <!-- Application Settings Modal -->
            <template v-slot:default="{ isActive }">
              <v-card :title="$t('pages.app.applicationSettings')" class="mb-3" v-bind="isActive">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-switch style="font-size: 11px;" color="success" v-model="autoSpeechOnChecking"
                        @change="handleAutoSpeechOnChecking" :label="$t('pages.app.autoSpeechOnChecking')" hide-details
                        inset></v-switch>

                      <v-switch v-bind:class="{ 'just-disabled': !clipboardGranted }" color="success"
                        v-model="autoDetectClipboardChange" @change="handleAutoDetectClipboardChange"
                        :label="$t('pages.app.autoDetectClipboardChange')" hide-details inset></v-switch>


                      <v-dialog max-width="500">
                        <template v-slot:activator="{ props: activatorProps }">
                          <div v-if="!clipboardGranted" v-bind="activatorProps" @click="readClipboard" class="mb-2">
                            <v-text style="font-size: 12px;" class="text-danger" role="button"> {{
                              $t('pages.app.clipboardPermissionText') }}</v-text>
                          </div>
                        </template>

                        <template v-slot:default="{ isActive }">
                          <v-card :title="$t('pages.app.clipboardHelpTitle')">
                            <v-card-text>
                              <h4><v-icon color="#DB4437" icon="mdi-google-chrome" /> Chrome</h4>
                              <ul>
                                <li>{{ $t('pages.app.chromeStep1') }}</li>
                                <li>{{ $t('pages.app.chromeStep2') }}</li>
                                <li>{{ $t('pages.app.chromeStep3') }}</li>
                                <li>{{ $t('pages.app.chromeStep4') }}</li>
                              </ul>

                              <h4><v-icon color="#FF9400" icon="mdi-firefox" /> Firefox</h4>
                              <ul>
                                <li>{{ $t('pages.app.firefoxStep1') }}</li>
                                <li>{{ $t('pages.app.firefoxStep2') }}</li>
                                <li>{{ $t('pages.app.firefoxStep3') }}</li>
                              </ul>

                              <h4><v-icon color="#1E90FF" icon="mdi-apple-safari" /> Safari</h4>
                              <ul>
                                <li>{{ $t('pages.app.safariStep1') }}</li>
                                <li>{{ $t('pages.app.safariStep2') }}</li>
                                <li>{{ $t('pages.app.safariStep3') }}</li>
                              </ul>
                              <h5>{{ $t('pages.app.otherBrowserTitle') }}</h5>
                              <ul>
                                <li>
                                  {{ $t('pages.app.otherBrowserStep1') }}
                                </li>
                              </ul>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn :text="$t('public.close')" @click="isActive.value = false"></v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>



                      <v-text v-if="!t2sSupported" style="font-size: 12px;" class="text-danger m-0 p-0">Your browser
                        {{ $t('pages.app.speechNotSupported') }}
                      </v-text>
                      <div v-bind:class="{ 'disabled': !t2sSupported }">


                        <h5 class="mt-0">
                          {{ $t('pages.app.ttsSettings') }}
                        </h5>
                        <v-row>
                          <v-col cols="8">
                            <v-text-field :label="$t('pages.app.sampleText')" v-model="sampleText"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-btn color="primary" icon="mdi-play" size="55" @click="textToSpeech(sampleText)"></v-btn>
                          </v-col>
                        </v-row>
                        <div class="text-caption"> {{ $t('pages.app.rate') }}</div>
                        <v-slider show-ticks="always" step="10" tick-size="4" v-model="speechRate"
                          @mouseleave="soundSettingsChange" :hint="$t('pages.app.rateHint')" persistent-hint></v-slider>
                        <div class="text-caption mt-3">{{ $t('pages.app.pitch') }}</div>

                        <v-slider show-ticks="always" step="10" tick-size="4" v-model="speechPitch"
                          @mouseleave="soundSettingsChange" :hint="$t('pages.app.pitchHint')"
                          persistent-hint></v-slider>
                        <div class="text-caption mt-3">{{ $t('pages.app.volume') }}</div>

                        <v-slider show-ticks="always" step="10" tick-size="4" v-model="speechVolume"
                          @mouseleave="soundSettingsChange" :hint="$t('pages.app.volumeHint')"
                          persistent-hint></v-slider>

                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn :text="$t('public.close')" @click="isActive.value = false"></v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
          <router-link to="/Friends" class="nav-link">
            <v-badge :model-value="this.userInfoStore.friendshipPending > 0"
              :content="this.userInfoStore.friendshipPending" color="danger" class="w-100 pe-2">
              <v-list-item prepend-icon="mdi-account-group" :title="$t('pages.app.friends')"></v-list-item>
            </v-badge>
          </router-link>
          <router-link to="/MessagesList" class="nav-link">
            <v-badge :model-value="this.userInfoStore.messagesUnread > 0" :content="this.userInfoStore.messagesUnread"
              color="danger" class="w-100 pe-2">
              <v-list-item prepend-icon="mdi-forum" :title="$t('pages.app.messages')"></v-list-item>
            </v-badge>
          </router-link>
          <v-list-group value="language">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" prepend-icon="mdi-translate"
                :title="$t('app.language') + ' (' + currentLang.toUpperCase() + ')'" />
            </template>

            <v-list-item @click="changeLang('en-GB')" title="English" />
            <v-list-item @click="changeLang('fa-IR')" title="فارسی" />
            <v-list-item @click="changeLang('de-DE')" title="Deutsch" />
            <v-list-item @click="changeLang('fr-FR')" title="Français" />
            <v-list-item @click="changeLang('es-ES')" title="Español" />
            <v-list-item @click="changeLang('ru-RU')" title="Русский" />
            <v-list-item @click="changeLang('tr-TR')" title="Türkçe" />
            <v-list-item @click="changeLang('hi-IN')" title="हिन्दी" />
            <v-list-item @click="changeLang('zh-CN')" title="中文" />
            <v-list-item @click="changeLang('ar-SA')" title="العربية" />



          </v-list-group>

        </v-list>
      </v-navigation-drawer>

      <!-- App Bar - Need Authorize -->
      <v-app-bar v-if="$route.meta.Authorize" style="width: 448px;left: 50%;transform: translateX(-50%);"
        color="teal-darken-4" image="images/bg.webp" :title="$t('app.title')">

        <template v-slot:prepend>
          <v-btn :disabled="currentPage == 'boxes'" @click="goBack"
            :icon="lang.isRtl ? 'mdi-arrow-right' : 'mdi-arrow-left'"></v-btn>
        </template>
        <template v-slot:image>
          <v-img gradient="to top right, #2d16d56b, #f98f436b"></v-img>
        </template>

        <v-btn icon v-if="showWebAppButton" @click="handleInstallPWA">
          <v-icon>mdi-open-in-app</v-icon>
        </v-btn>

        <v-btn icon @click.stop="drawer = !drawer">
          <v-badge v-if="this.userInfoStore.friendshipPending + this.userInfoStore.messagesUnread > 0"
            :content="this.userInfoStore.friendshipPending + this.userInfoStore.messagesUnread" color="danger">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-badge>
          <v-icon
            v-if="this.userInfoStore.friendshipPending + this.userInfoStore.messagesUnread == 0">mdi-dots-vertical</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Router View -->
      <v-main style="min-height: 100vh;padding-left: 0;">
        <router-view />
        <v-fab v-if="$route.meta.Authorize && !['reviewvocabulary', 'checkvocabulary'].includes(currentPage)" style="
                      transform: translate(calc(-50% - 15px), -37px);
                      position: fixed;
                      bottom: 0px;
                      max-width: 100%;
                      left: 50%;
                      width: 448px;" key="absolute" :absolute="true" :app="false" :color="fab_open ? '' : 'primary'"
          location="absolute" size="large" icon>
          <v-icon>{{ fab_open ? 'mdi-close' : 'mdi-menu' }}</v-icon>
          <v-speed-dial v-model="fab_open" location="bottom center" transition="scale-transition" activator="parent">
            <router-link :to="'/AddVocabulary'" key="1">
              <v-btn color="success" icon>
                <v-icon size="24">mdi-receipt-text-plus</v-icon>
              </v-btn>
            </router-link>

            <router-link :to="'/Vocabularies'" key="2">
              <v-btn color="info" icon>
                <v-icon size="24">mdi-receipt-text</v-icon>
              </v-btn>
            </router-link>

            <router-link :to="'/Boxes'" key="3">
              <v-btn color="warning" icon>
                <v-icon size="24">mdi-inbox-multiple</v-icon>
              </v-btn>
            </router-link>




          </v-speed-dial>
        </v-fab>
      </v-main>

    </v-layout>
  </v-card>

  <!-- Loading overally Component -->
  <Loading />

  <!-- Text Selection or Clipboard Bar -->
  <v-container v-if="$route.meta.Authorize"
    v-bind:class="{ 'show': $route.meta.Authorize && selection.showBarLevel == 2 }" class="selection-bar">
    <v-row>
      <v-col>
        <v-spacer></v-spacer>
        <router-link v-show="!selection.isAdded" @click="selection.showBarLevel = 0" class="navbar-brand"
          :to="{ path: `/AddVocabulary/${selection.text}` }">
          <v-btn color="success" size="xs-small" class="p-1 mb-2" prepend-icon="mdi-book-alphabet">Add {{ selection.text
          }}
            To
            My Words</v-btn>
        </router-link>
        <router-link v-show="selection.isAdded" @click="selection.showBarLevel = 0" class="navbar-brand"
          :to="`/Vocabularies?text=${selection.text}`">
          <v-btn color="success" size="xs-small" class="p-1 mb-2" prepend-icon="mdi-receipt-text">View {{ selection.text
          }}
            In My List</v-btn>
        </router-link>
      </v-col>
    </v-row>

  </v-container>
  <v-container class="selection-bar-toggler"
    v-bind:class="{ 'show': $route.meta.Authorize && selection.showBarLevel > 0 }" v-if="$route.meta.Authorize">
    <v-text class="h3" block>{{ selection.text }}</v-text>
    <v-icon @click="openToggler" class="open-btn"
      v-if="selection.showBarLevel == 1 && $route.meta.Authorize">mdi-arrow-down-drop-circle</v-icon>
    <v-icon @click="selection.showBarLevel = 0; selection.text = ''"
      v-if="$route.meta.Authorize">mdi-close-circle</v-icon>
  </v-container>



  <!-- Application update dialog -->
  <v-dialog v-model="updateDialog" persistent max-width="420">
    <v-card style="overflow:visible;" rounded="xl" class="pa-2">

      <v-card-text class="text-center pt-6">

        <!-- Success icon -->
        <div class="d-flex align-center justify-center" style="gap:10px; transform:translateY(-100%); z-index:2;">
          <v-avatar color="success" size="56">
            <v-icon color="white" size="30">mdi-check</v-icon>
          </v-avatar>
        </div>

        <!-- Update success title -->
        <div class="text-h6 font-weight-bold mb-2" style="margin-top:-50px;">
          Update completed successfully
        </div>

        <!-- Version only (if changelog is empty) -->
        <div v-if="newChanges.length == 0" class="text-caption">
          {{ newVersion }}
        </div>

        <!-- Changelog section -->
        <div v-if="newChanges.length > 0">

          <div class="text-caption text-medium-emphasis mb-3">
            Latest changes in recent versions
          </div>

          <!-- Scrollable area -->
          <div class="rounded-lg bg-grey-lighten-4 pa-3" style="max-height:220px; overflow-y:auto;">

            <!-- Each version block -->
            <div v-for="(version, vIndex) in newChanges" :key="vIndex" class="mb-4">
              <!-- Version title -->
              <div class="text-subtitle-2 font-weight-bold mb-2">
                Version {{ version.Version }}
              </div>

              <!-- Changes -->
              <div v-for="(change, cIndex) in version.Changes" :key="cIndex" class="d-flex align-start py-1"
                style="gap:6px;">
                <v-icon color="success" size="16" class="mt-1">
                  mdi-check-circle
                </v-icon>

                <span class="text-body-2">
                  {{ change }}
                </span>
              </div>

              <v-divider v-if="vIndex !== newChanges.length - 1" class="mt-3" />
            </div>

          </div>

        </div>

      </v-card-text>

      <!-- Dialog actions -->
      <v-card-actions class="justify-center pb-4">
        <v-btn color="success" variant="elevated" rounded="lg" min-width="120" @click="onOkClickUpdateDialog">
          Got it
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

</template>

<script>
import debounce from 'lodash/debounce';
import Loading from './components/Loading.vue';
import { useUserInfoStore } from './stores/userInfoStore';
import { useLangStore } from './stores/langStore.js';


export default {
  name: 'App',
  components: {
    Loading,
  },
  data() {
    return {
      currentLang: this.$i18n.locale,
      updateDialog: false,
      fab_open: false,
      togglerAutoClose: null,
      drawer: null,
      speechPitch: localStorage.getItem('speechPitch') ? parseFloat(localStorage.getItem('speechPitch')) * 100 : 100,
      speechRate: localStorage.getItem('speechRate') ? parseFloat(localStorage.getItem('speechRate')) * 100 : 100,
      speechVolume: localStorage.getItem('speechVolume') ? parseFloat(localStorage.getItem('speechVolume')) * 100 : 100,
      sampleText: 'Dream Vocab Box',
      autoDetectClipboardChange: localStorage.getItem('autoDetectClipboardChange') == 'true',
      autoSpeechOnChecking: localStorage.getItem('autoSpeechOnChecking') == 'true',
      clipboardGranted: false,
      lastClipboardText: '',

      showWebAppButton: false,
      deferredPrompt: null,
      suggestion: {
        Show: false,
        Word: '',
        Definition: {}
      },
      selection: {
        showBarLevel: 0,
        isAdded: false,
        text: ''
      },
      userInfoStore: useUserInfoStore(),
      currentPage: 'boxes',
      profile: {
        nickname: '',
        avatar: 0,
        email: '',
        boxscenario: '',
        username: '',
        password: '',
      }
    };
  },
  computed: {
    boxScenarios() {
      return [
        {
          Id: 0,
          Title: this.$t('pages.app.scenario1Title'),
          Description: this.$t('pages.app.scenario1Desc'),
        },
        {
          Id: 1,
          Title: this.$t('pages.app.scenario2Title'),
          Description: this.$t('pages.app.scenario2Desc'),
        },
        {
          Id: 2,
          Title: this.$t('pages.app.scenario3Title'),
          Description: this.$t('pages.app.scenario3Desc'),
        },
      ]
    },

    selectedScenario() {
      return this.boxScenarios.find(
        s => s.Id === this.profile.boxscenario
      )
    }
  },
  watch: {
    // eslint-disable-next-line
    $route(to, from) {
      this.selection.showBarLevel = 0;
      this.selection.text = '';
      this.currentPage = to.path.split('/')[1]?.toLowerCase() || '';
    }
  },
  async mounted() {
    if (localStorage.getItem('lang') == null)
      localStorage.setItem('lang', 'en-GB');

    if (localStorage.getItem('autoSpeechOnChecking') == null)
      localStorage.setItem('autoSpeechOnChecking', 'false');

    window.addEventListener('focus', () => this.checkClipboard());
    this.checkClipboard();


    // ----------------------------
    // PWA installation logic
    // ----------------------------
    // Register the Service Worker and listen for updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {

          // Detect when a new service worker is found
          reg.onupdatefound = () => {

            const newWorker = reg.installing;
            if (!newWorker) return;

            newWorker.onstatechange = () => {

              // If a new service worker finished installing
              // and another SW is already controlling the page
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                console.log("New service worker installed");
              }

            };

          };

        })
        .catch(err => console.error("Service worker registration failed:", err));

      // Listen for messages from the Service Worker (registered only once)
      navigator.serviceWorker.addEventListener(
        "message",
        this.handleServiceWorkerMessage
      );
    }
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.showWebAppButton = true;
      this.deferredPrompt = e;
      return false;
    });
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
      this.showWebAppButton = false;
    }
    else if (this.deferredPrompt) {
      this.showWebAppButton = true;
    }
    window.addEventListener('appinstalled', () => this.showWebAppButton = false);
    // End Install PWA

    document.addEventListener("selectionchange", this.handleSelectionChange);
    if (localStorage.getItem('token') != null) {
      await this.fillProfile();
    }
  },
  beforeUnmount() {
    document.removeEventListener("selectionchange", this.handleSelectionChange);
  },
  setup() {
    const lang = useLangStore()
    return { lang }
  },
  methods: {
    changeLang(lang) {
      this.lang.applyLanguage(lang, this.$i18n, this.$vuetify)
    },
    onOkClickUpdateDialog() {

      window.location.reload()

    },
    handleServiceWorkerMessage(event) {

      // Check if the service worker notifies that an update was applied
      if (event?.data?.type === 'SW_UPDATED') {

        // Store the new version sent by the service worker
        this.newVersion = event.data.version;

        // Fetch changelog information for the updated version
        fetch('/changelog.json', { cache: "no-store" })
          .then(res => res.json())
          .then(changelog => {

            const limit = 5;

            this.newChanges = changelog
              .slice(-limit)
              .reverse();

            this.updateDialog = true;

          })
          .catch(err => console.error("error:", err));


      }

    },
    async openToggler() {
      this.selection.showBarLevel = 2;
      const response = await this.postRequest('Vocabularies', 'CheckVocabulary', this.selection.text, false);
      this.selection.isAdded = response.IsSuccess && response.Data;
    },
    soundSettingsChange() {
      localStorage.setItem('speechPitch', this.speechPitch / 100);
      localStorage.setItem('speechRate', this.speechRate / 100);
      localStorage.setItem('speechVolume', this.speechVolume / 100);
    },
    checkClipboard() {
      try {
        if (localStorage.getItem('token'))
          navigator.permissions.query({ name: "clipboard-read" }).then((result) => {
            if (result.state === "granted") {
              if (localStorage.getItem('autoDetectClipboardChange') == null)
                localStorage.setItem('autoDetectClipboardChange', 'true');
              this.clipboardGranted = true;
              if (this.autoDetectClipboardChange) {
                this.readClipboard();
              }
            } else if (result.state === "prompt") {
              this.readClipboard();
            } else {
              this.clipboardGranted = false;
              localStorage.setItem('autoDetectClipboardChange', 'false');
            }
          });
      } catch (error) {
        console.log(error);
      }

    },
    readClipboard() {
      try {
        if (this.togglerAutoClose != null)
          this.togglerAutoClose.cancel();
        navigator.clipboard.readText().then((text) => {
          this.clipboardGranted = true;
          localStorage.setItem('autoDetectClipboardChange', 'true');
          if (text.trim().split(/\s+/).length > 2 || text.trim().length > 30 || !text.trim() || this.lastClipboardText === text.trim()) {
            return;
          }
          this.selection.showBarLevel = 1;
          this.togglerAutoClose = debounce(() => {
            if (this.selection.showBarLevel === 1) {
              this.selection.showBarLevel = 0;
              this.selection.text = '';
              this.togglerAutoClose.cancel();
            }
          }, 3000);
          this.togglerAutoClose();
          this.selection.text = text.trim();
          this.lastClipboardText = text.trim();
        }).catch(() => {
          this.clipboardGranted = false;
          localStorage.setItem('autoDetectClipboardChange', 'false');
        });
      } catch (error) {
        console.log(error);
      }

    },
    handleAutoSpeechOnChecking() {
      localStorage.setItem('autoSpeechOnChecking', this.autoSpeechOnChecking);
    },
    handleAutoDetectClipboardChange() {
      localStorage.setItem('autoDetectClipboardChange', this.autoDetectClipboardChange);
    },
    handleInstallPWA() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.showWebAppButton = false;
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted')
            this.showWebAppButton = false;
          else
            this.showWebAppButton = true;
        });
      }
      else
        this.showWebAppButton = false;

    },
    handleSelectionChange: debounce(function () {
      const userSelection = window.getSelection().toString().trim();
      if (userSelection.split(/\s+/).length > 2 || userSelection.length > 30) {
        this.selection.showBarLevel = 0;
        this.selection.text = '';
        return;
      }
      if (this.togglerAutoClose != null)
        this.togglerAutoClose.cancel();
      if (!userSelection) {
        if (this.selection.showBarLevel === 1) {
          this.selection.showBarLevel = 0;
          this.selection.text = '';
        }
      } else if (this.selection.text !== userSelection) {
        this.selection.showBarLevel = 1;
        this.togglerAutoClose = debounce(() => {
          if (this.selection.showBarLevel === 1) {
            this.selection.showBarLevel = 0;
            this.selection.text = '';
            this.togglerAutoClose.cancel();
          }
        }, 3000);
        this.togglerAutoClose();
        this.selection.text = userSelection;
      }
    }, 500),
    async updateProfile() {
      const response = await this.postRequest('Users', 'UpdateProfile', this.profile);
      this.notyf.apiResult(response);
      if (response.IsSuccess) {
        localStorage.setItem("token", response.Data.Token);
        this.userInfoStore.reloadValues();
        if (this.currentPage == 'boxes') {
          this.shared.toggle_getVocabulariesBoxes();
        }
      }

    },
    goBack() {
      this.$router.back(-1);
    },
    logout() {
      localStorage.removeItem("token");
      this.userInfoStore.emptyValues();

      this.$router.push('/Login');
    },
    async fillProfile() {
      await this.userInfoStore.reloadValues();

      this.profile.nickname = this.userInfoStore.nickname;
      this.profile.avatar = this.userInfoStore.avatar;
      this.profile.email = this.userInfoStore.email;
      this.profile.username = this.userInfoStore.username;
      this.profile.boxscenario = this.userInfoStore.boxscenario;
      this.profile.password = '';
    }





  }
};
</script>
<style></style>